export const firebaseConfig = {
  apiKey: 'AIzaSyDbQVDHBbSMEXaIQY20jCJoBzvipdm67Uc',
  authDomain: 'interviewium-dev.firebaseapp.com',
  databaseURL:
    'https://interviewium-dev-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'interviewium-dev',
  storageBucket: 'interviewium-dev.appspot.com',
  messagingSenderId: '690351080774',
  appId: '1:690351080774:web:9ad2cf6b286747ba451147',
  measurementId: 'G-JDFE37SH0H',
};
